<template>
    <div>
        <div class='photo-upload-space'>
            <div class='input-wrapper'>
                <p class='drop-area'> クリック、またはドラッグをして写真を追加 </p>
                <input type='file' name='upload-photo' ref='uploadFiles' class='upload-photos' @change='addUploadPhotos' accept="image/*" multiple>
            </div>
        </div>
        <p class='upload-text'>アップロード待機: {{ uploadPhotos.length }} 件</p>
        <div v-if='failedPhotoNames.length'>
            <p>アップロードに失敗した写真</p>
            <p class='failed-photo-name' v-for='(failedPhotoName, i) in failedPhotoNames' :key='i'>{{ failedPhotoName }}</p>
        </div>
        <button class='button is-info is-fullwidth is-medium upload' @click='upload'>アップロード</button>
        <button class='button is-danger is-fullwidth is-medium delete-btn' @click='deletePhotos'>削除</button>
        <button class='button is-success is-fullwidth is-medium rekognition' @click='rekognition' v-bind:disabled='!!selectEvent.face_recognition'>顔認証開始</button>
        <p>※補正が完了した写真のみ表示しています</p>
        <p>アップロード済み: {{ totalPhotoCount }}件</p>
        <p>補正済み {{ correctedPhotoCount }}件</p>
        <div class='photos'>
            <div v-for='photo in photos' :key='photo.id' class='photo-wrap'>
                <!-- <img v-if='photo.reduction_s3_key' :src='`${photoBaseUrl}/${photo.reduction_s3_key}`' :class='{ selected : selectPhotoMap[photo.id] }' @click='selectImage(photo.id)'>
                <img v-else :src='`${photoBaseUrl}/${photo.s3_key}`' :class='{ selected : selectPhotoMap[photo.id] }' @click='selectImage(photo.id)'> -->
                <img v-if='photo.reduction_s3_key' :src='`${photoBaseUrl}/${photo.reduction_s3_key}`' :class='{ selected : selectPhotoMap[photo.id] }' @click='selectImage(photo.id)' loading='lazy' decoding='async'>
                <p class='photo-name'> {{ photo.name }}</p>
            </div>
        </div>
        <p v-if='loadingPhotos' class='loading-text'>写真を読み込み中...</p>
    </div>
</template>
<script>

import upload from '@/helpers/upload'

export default {
    name: 'Upload',
    props: ['selectEvent'],
    components: {
    },
    data () {
        return {
            photoBaseUrl: process.env.PHOTO_BASE_URL,
            uploadPhotos: [],
            photos: [],
            failedPhotoNames: [],
            selectPhotoMap: {},
            currentPage: 1,
            pageSize: 40,
            hasMore: true,
            loadingPhotos: false,
            totalPhotoCount: 0,
            correctedPhotoCount: 0,
            scrollHandler: null,
            photoRequestId: 0,
            getViewPhotosHandler: null
        }
    },
    mounted () {
        const self = this

        this.scrollHandler = () => {
            if (self.loadingPhotos || !self.hasMore) return
            const bottomOfWindow = window.scrollY + window.innerHeight >= document.documentElement.offsetHeight - 300
            if (bottomOfWindow) {
                self.fetchPhotos()
            }
        }
        window.addEventListener('scroll', this.scrollHandler, { passive: true })

        this.getViewPhotosHandler = () => {
            const schoolId = self.$parent.$parent.selectSchoolId
            const yearId = self.$parent.$parent.selectYearId
            const eventId = self.$parent.$parent.selectEventId
            const requestId = ++self.photoRequestId
            const failedPhotoNames = JSON.parse(sessionStorage.getItem(`${schoolId}-${yearId}-${eventId}`))

            if (failedPhotoNames) {
                self.failedPhotoNames = failedPhotoNames
                sessionStorage.removeItem(`${schoolId}-${yearId}-${eventId}`)
            } else {
                self.failedPhotoNames = []
            }
            self.resetPhotos()
            if (!Number(eventId)) {
                if (self.$root.getPhotoData) self.$root.$emit('notification', 'is-primary', '左メニューの学校管理より学校、年度、行事を登録してください')
                self.$root.$emit('photosLoaded')
                return
            }

            self.fetchPhotos(true, requestId, eventId)
        }
        this.$root.$on('getViewPhotos', this.getViewPhotosHandler)

        this.$root.$emit('getViewPhotos')
    },
    beforeDestroy () {
        if (this.scrollHandler) {
            window.removeEventListener('scroll', this.scrollHandler)
        }
        if (this.getViewPhotosHandler) {
            this.$root.$off('getViewPhotos', this.getViewPhotosHandler)
        }
        this.photoRequestId++
    },
    methods: {
        resetPhotos () {
            this.photos = []
            this.currentPage = 1
            this.hasMore = true
            this.loadingPhotos = false
            this.totalPhotoCount = 0
            this.correctedPhotoCount = 0
        },
        fetchPhotos (notifyParent, requestId = this.photoRequestId, requestEventId = null) {
            if (this.loadingPhotos || !this.hasMore) return

            const eventId = requestEventId || this.$parent.$parent.selectEventId
            if (!Number(eventId)) return
            const isCurrentRequest = () => {
                return requestId === this.photoRequestId && String(eventId) === String(this.$parent.$parent.selectEventId)
            }

            this.loadingPhotos = true

            this.axios.post(`${process.env.API_URL}/photographer/photos`, {
                eventId,
                page: this.currentPage,
                limit: this.pageSize
            }).then((res) => {
                if (!isCurrentRequest()) return

                this.photos = this.photos.concat(res.data.photos)
                this.totalPhotoCount = res.data.totalCount
                this.correctedPhotoCount = res.data.correctedPhotoCount
                this.hasMore = res.data.hasMore
                this.currentPage++
            }).catch(() => {
                if (!isCurrentRequest()) return
                alert('画像の取得に失敗しました')
            }).finally(() => {
                if (!isCurrentRequest()) return

                this.loadingPhotos = false
                if (notifyParent) this.$root.$emit('photosLoaded')
            })
        },
        async addUploadPhotos (e) {
            const uploadPhotos = e.target.files
            for (const photo of uploadPhotos) {
                const size = await this.sizeOf(photo)
                if (size.width < 800 && size.height < 800) {
                    const result = window.confirm(`サイズの小さい写真（${photo.name}）が含まれています。このまま追加しますか？`)
                    if (!result) continue
                }
                this.$data.uploadPhotos.push(photo)
            }
        },
        async upload () {
            const self = this
            const parent = self.$parent.$parent

            if (!parent.selectEventId) {
                self.$root.$emit('notification', 'is-danger', `学校管理より学校、学年、行事を登録し上部バナーより選択してください`)
                return
            }

            if (!this.$data.uploadPhotos.length) {
                self.$root.$emit('notification', 'is-danger', `写真を追加してください`)
                return
            }

            self.$root.$emit('notification', 'is-primary', `アップロードを開始しました。しばらく時間がかかる可能性があります。そのままお待ちください。`)

            await upload(this, this.$data.uploadPhotos, parent.selectSchoolId, parent.selectYearId, parent.selectEventId, '')
            this.uploadPhotos = []
            this.$refs.uploadFiles.value = ''
            self.$root.$emit('getViewPhotos')
        },
        async sizeOf (image) {
            return new Promise((resolve, reject) => {
                const img = new Image()

                img.onload = () => {
                    resolve({
                        width: img.naturalWidth,
                        height: img.naturalHeight
                    })

                    URL.revokeObjectURL(img.src)
                }

                img.src = URL.createObjectURL(image)
            })
        },
        selectImage (photoId) {
            if (!this.selectPhotoMap[photoId]) {
                this.$set(this.selectPhotoMap, photoId, true)
            } else {
                this.$delete(this.selectPhotoMap, photoId)
            }
        },
        deletePhotos () {
            const self = this
            const keys = Object.keys(this.selectPhotoMap)

            if (!keys.length) {
                self.$root.$emit('notification', 'is-danger', `写真を選択してください`)
                return
            }

            this.axios.delete(`${process.env.API_URL}/photographer/photo`, {
                data: { ids: keys }
            }).then((res) => {
                keys.forEach((key) => {
                    this.$delete(this.selectPhotoMap, key)
                })

                this.photos = this.photos.filter((photo) => {
                    return !keys.includes(String(photo.id))
                })
                this.totalPhotoCount -= keys.length
                this.correctedPhotoCount = Math.max(this.correctedPhotoCount - keys.length, 0)

                self.$root.$emit('notification', 'is-primary', `写真の削除が完了しました`)
            }).catch((e) => {
                self.$root.$emit('notification', 'is-danger', `写真の削除に失敗しました`)
            })
        },
        rekognition () {
            if (!this.selectEvent.setting.sizes) {
                alert('行事を選択してください。')
                return
            }
            if (window.confirm('顔認証は全ての画像をアップロードが完了した後に行います。完了していればOKを押してください。')) {
                const eventId = this.selectEvent.id

                // 通常写真のサイズが無ければ顔認証しない
                let donot = false
                this.selectEvent.setting.sizes.forEach((size) => {
                    if (
                        size.use &&
                        size.name !== 'L' &&
                        size.name !== 'L-DSC' &&
                        size.name !== 'L-WIDE' &&
                        size.name !== 'ハガキ' &&
                        size.name !== 'データ販売' &&
                        size.name !== 'パノラマ'
                    ) {
                        donot = true
                    }
                })

                if (!donot || window.confirm('詳細設定 > 選択可能サイズ に2L以上のサイズが含まれています。集合写真は顔認証の対象ではありませんが操作を続けますか？')) {
                    this.$root.$emit('notification', 'is-primary', `顔認証を開始します。顔認証には時間がかかる可能性があります。ページを閉じていただいても構いません。`)
                    this.axios.post(`${process.env.API_URL}/photographer/rekognition`, { eventId }).then((res) => {
                        this.$root.$emit('notification', 'is-primary', res.data.message)
                    }).catch((e) => {
                        this.$root.$emit('notification', 'is-danger', `リクエストに失敗しました。時間をおいてもう一度お試しください。`)
                    })
                }
            }
        }
    }
}
</script>

<style scoped>

.photo-upload-space  {
    margin-top: 20px;
}

.input-wrapper {
    position: relative;
    text-align: center;
    background: white;
    padding-top: 3px;
}

.drop-area {
    width: 100%;
    height: 150px;
    padding: 50px 0 0;
    border: 4px dashed rgb(227, 227, 227);
    border-radius: 5px;
    font-size: 25px;
    color: rgb(147, 147, 147)
}

.upload-photos {
    cursor: pointer;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    display: block;
    width: 100%;
    height: 150px;
    opacity: 0;
}

.upload {
    font-weight: bold;
}

.upload-text {
    margin-top: 15px;
}

.button {
    margin-top: 18px;
    height: 52px;
    font-size: 18px;
    border-radius: 10px;
}

.upload,
.delete-btn,
.rekognition {
    letter-spacing: 0.02em;
}

.photos {
    margin-top: 70px;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-auto-flow: row;
    gap: 14px;
}

.photo-wrap {
    width: 100%;
    margin: 0;
    border: 1px solid rgba(0, 0, 0, 0.1);
}

.photo-name {
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    padding: 3px;
    padding-left: 7px;
}

.photo-wrap > img {
    width: 100%;
    cursor: pointer;
}

.selected {
    border: 3px solid rgba(20, 50, 205, 1) !important;
}

.failed-photo-name {
    color: rgb(200, 20, 20);
}

.loading-text {
    margin-top: 18px;
    text-align: center;
    color: rgb(90, 90, 90);
}

</style>



// WEBPACK FOOTER //
// src/components/photographer/pages/Upload.vue